<template>
  <v-main>
    <v-container class="fill-height" fluid style="background-color: #ccc">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-row align="center" justify="center">
            <v-col cols="12" align="center">
              <h1 class="text-center mb-5">{{ $t('forgot.title') }}<br /></h1>
              <h1 class="text-center mb-5">{{ $t('forgot.forgot') }}<br /></h1>
            </v-col>
          </v-row>
          <resetPass v-if="showReset" :itemSelected="user" :otp="true" @update="afterReset()"></resetPass>

          <v-card class="elevation-12" v-if="!showReset">
            <v-card-text>
              <div align="center">
                <!-- <v-avatar size="120px"> -->
                <img height="60" :src="staticPath + 'logo_tai.jpg'" />
                <LangSelect class="set-language" v-if="false" />
                <!-- <br/><br/> -->
                <!-- <p>โปรดกรอก ชื่อผู้ใช้ และ รหัสผ่าน<br> -->
                <!-- <span style="font-size:12px;color:#252525">(โดยใช้ชุดเดียวกันกับตอนล็อกอินบนเครื่องคอมพิวเตอร์ที่<br>สถาบันยานยนต์)</span> -->
                <!-- </p> -->
                <!-- </v-avatar> -->
              </div>
              <v-form v-model="valid" ref="form" @submit.prevent>
                <v-text-field
                  ref="username"
                  :label="$t('login.username')"
                  prepend-inner-icon="mdi-account"
                  class="my-5"
                  hint=""
                  v-model="user.username"
                  :rules="nameRules"
                  @keyup.enter="forgotPass()"
                  autofocus
                  required
                  :disabled="loading"
                ></v-text-field>
              </v-form>
              <v-alert v-if="error !== ''" outline color="error" icon="warning" :value="true">
                {{ error }}
              </v-alert>
              <v-alert type="warning" :value="$browserDetect.isIE"> กรุณาเปิดด้วย Chrome หรือ Firefox หรือ Safari </v-alert>
            </v-card-text>
            <v-progress-linear v-bind:indeterminate="true" v-if="loading"></v-progress-linear>

            <v-card-actions v-if="!showReset">
              <v-spacer></v-spacer>
              <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey"> </vue-recaptcha>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-actions>
              <h6 class="red--text text-center">{{ $t('forgot.remark') }}</h6>
            </v-card-actions>
            <v-card-actions>
              <!-- <v-spacer /> -->
              <v-btn block @click="forgotPass()" :disabled="loading" :class="{ primary: valid, error: !valid }">{{ $t('forgot.sendOTP') }}</v-btn>
            </v-card-actions>
          </v-card>

          <!-- <v-alert color="error" class="white--text">{{$browserDetect}}หมายเหตุ : กรุณากด Ctrl+F5 เพื่อรับ Version ใหม่ของโปรแกรม</v-alert> -->

          <v-card class="mt-5">
            <v-card-actions>
              <v-btn text block class="blue--text" @click="signIn">{{ $t('forgot.gotologin') }}</v-btn>
            </v-card-actions>
          </v-card>

          <br /><br />
          <div style="font-size: 14px" class="lockscreen-footer text-center">Ver:1.20.0 Build:20240307.015017</div>
          <div class="lockscreen-footer text-center">
            Copyright © 2019
            <b><a href="#" class="text-black"></a></b><br />
            All rights reserved
          </div>
        </v-col>
      </v-row>
      <v-snackbar v-model="showUpdate" timeout="3000" top @input="snackInput">
        {{ showText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="showUpdate = loading = false"> ปิด </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { mapActions } from 'vuex'
import itemServe from '@/store/api/services/customersService'
import resetPass from '@/components/customers/userResetPassword'
import LangSelect from '@/components/LangSelect'
// import browserDetect from 'vue-browser-detect-plugin'

export default {
  name: 'login',
  components: {
    LangSelect,
    VueRecaptcha,
    resetPass
  },
  data() {
    return {
      showReset: false,
      sitekey: '6LfRYwAgAAAAAGvIRAzdtN823T4sdbvJLzgHj_8D',
      recapcha: '',
      showUpdate: false,
      showText: '',
      showpass: false,
      version: '1.20.0',
      apiPath: process.env.VUE_APP_API_PATH.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      staticPath: process.env.VUE_APP_STATIC.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      userReset: {},
      user: {
        username: '',
        password: '',
        version: '1.20.0'
      },
      redirect: '',
      valid: false,
      loading: false,
      error: '',
      browser: '',

      // nameRules: [(v) => !!v || 'กรุณาใส่ UserName', (v) => v.length >= 5 || 'ชื่อต้องไม่น้อยกว่า 5 ตัวอักษร'],
      passwordRules: [(v) => !!v || 'กรุณาใส่ Password', (v) => v.length >= 6 || 'ชื่อต้องไม่น้อยกว่า 6 ตัวอักษร'],
      nameRules: [
        (val) => {
          // email check
          const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return patternEmail.test(val) || 'Invalid e-mail.'
        },
        (val) => this.recapcha !== '' || 'reCAPTCHA is required.' + this.recapcha
      ]
    }
  },

  mounted() {
    // browser = $browserDetect
    console.log('browser', this.browser)
    console.log('process.env', process.env)
    window.localStorage.clear()
    localStorage.setItem('isoList-pagination', '')
    localStorage.setItem('isoList-process', '')
    localStorage.setItem('isoList-filter', '')
    localStorage.setItem('vuex', '')
    localStorage.setItem('EmpAll', '')
    let urlQuery = this.$route.query
    if (!!urlQuery.username) {
      this.showReset = true
      this.user.username = urlQuery.username
      this.user.OTP = urlQuery.token
    }
  },
  methods: {
    ...mapActions(['signIn']),
    afterRese(e) {
      // alert(JSON.stringify(e))
    },
    snackInput() {
      // this.userReset.username = this.user.username
      this.loading = false
      if (this.redirect !== '') {
        this.$router.push(this.redirect)
      }
    },
    clear() {
      this.user.username = ''
      this.user.password = ''
      this.loading = false
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.signIn()
      }
    },
    async signIn() {
      console.log('singIn')
      this.$router.push('/signin')
    },
    signOut() {
      this.$store.dispatch('signOut')
      this.$router.push('/signin')
    },
    async forgotPass() {
      if (this.valid) {
        // console.log('Register')
        this.loading = true
        this.error = ''

        this.redirect = ''
        let response = await itemServe.forgot(this.user)
        console.log('usersEdit Save Update then')
        if (response.error === '') {
          console.log('usersEdit Save Update then OK')
          // this.itemSelected = response.data.data[0]
          // let itemSelected_update = response.data.data[0] // this.itemSelected
          this.$emit('update', this.user)
          // this.loading = false
          this.showText = 'ระบบได้ส่งอีเมล์เพื่อตั้งรหัสผ่านใหม่ไปยังท่านแล้ว โปรดตรวจสอบอีเมล์ของท่าน'
          this.showUpdate = true
          this.showReset = true
          this.redirect = ''
          this.resetRecaptcha()
          // this.redirect = '/signin'
          // this.$router.push(this.redirect)
          return true
        } else {
          // this.loading = false
          console.log('usersEdit Save Update then error')
          // alert('!!เกิดข้อผิดพลาด\n' + response.error)
          this.showText = 'เกิดข้อผิดพลาด:ไม่สามารถดำเนินการได้' //response.error
          this.showUpdate = true
          this.redirect = ''
          this.resetRecaptcha()
          return false
        }
      }
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
      this.recapcha = response
      this.$refs.form.validate()
    },
    onExpired: function () {
      console.log('Expired')
      this.recapcha = ''
      this.$refs.form.validate()
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    }
  }
}
</script>

<style scoped>
.set-language {
  color: #fff;
  position: absolute;
  top: 3px;
  font-size: 18px;
  right: 0px;
  cursor: pointer;
}
</style>
